import { ClientVisitedActionEnum } from 'actions/lastVisitedClientAction'

export const lastVisitedClientReducer = (
    state: string | null = null,
    action: { type: string; clientCode: string | undefined }
): string | null => {
    switch (action.type) {
        case ClientVisitedActionEnum.CLIENT_VISITED:
            return action.clientCode ?? null
        case ClientVisitedActionEnum.CLIENT_CLEARED:
            return null
        default:
            return state
    }
}
